import { HSComponent } from "./component.js";
import * as Logger from "./logger.js";
import styles from "./stats-column-picker.css";
import template from "./stats-column-picker.html";
import { HSToolbarButton } from "./toolbar-button.js";
import { UserSession } from './session.js';

const PRESETS = [
    { id: 'summary', title: 'Summary' },
    { id: 'capacity', title: 'Capacity' },
    { id: 'activity', title: 'Activity' },
    { id: 'full', title: 'Full' },
];

export class HSStatsColumnPicker extends HSComponent {
    initialized = false;
    selectedPreset = 'summary';
    buttonsByPreset = {};

    constructor() {
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        this.init();
    }

    init() {
        if (!this.initialized) {
            this.buildButtons();
            this.initialized = true;
        }
        this.selectedPreset = this.resolvePreset(UserSession.get('statsColumnPreset'));
        this.selectPreset(this.selectedPreset, false);
    }

    resolvePreset(value) {
        const preset = String(value || '').trim().toLowerCase();
        return PRESETS.some(item => item.id === preset) ? preset : 'summary';
    }

    buildButtons() {
        const container = this.shadowRoot.querySelector('.container');
        if (!container) {
            return;
        }

        PRESETS.forEach(preset => {
            const button = document.createElement('hs-toolbar-button');
            button.classList.add('selectable');
            button.setAttribute('title', preset.title);
            button.setAttribute('action', `hs-stats-column-preset-${preset.id}`);
            container.appendChild(button);
            this.buttonsByPreset[preset.id] = button;
            this.onEvent(`hs-stats-column-preset-${preset.id}`, () => {
                this.selectPreset(preset.id, true);
            }, button);
        });
    }

    selectPreset(preset, emit = true) {
        const resolved = this.resolvePreset(preset);
        this.selectedPreset = resolved;
        Object.entries(this.buttonsByPreset).forEach(([id, button]) => {
            button.setSelected(id === resolved);
        });
        UserSession.set('statsColumnPreset', resolved);
        if (emit) {
            Logger.debug('Stats column preset changed: ', resolved);
            this.emit({
                type: 'hs-stats-column-preset-changed',
                preset: resolved,
            });
        }
    }
}

customElements.define("hs-stats-column-picker", HSStatsColumnPicker);